/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab.ts";
import { courseRegistrationManagementFinancialViewModelSchema } from "../courseRegistrationManagementFinancialViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab200Schema =
  z.lazy(
    () => courseRegistrationManagementFinancialViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse>;
